<template>
  <div>
    <v-card>
      <!-- <v-card-title> -->
      <v-row class="pa-5">
        <v-col cols="10" class="float-right text-right">
          <v-tabs v-model="tab" show-arrows>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#InfoDetail">
              <h6>جزییات</h6>
            </v-tab>
            <v-tab href="#Message">
              <h6>گفتگو با تامین‌کننده</h6>
            </v-tab>
            <v-tab href="#Event">
              <h6>سوابق اقدام</h6>
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="2" class="float-left text-left">
          <v-btn color="error" @click="closeForm()" icon>
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item :value="'InfoDetail'">
          <v-card-text flat>
            <trade-request-direct-information></trade-request-direct-information>
          </v-card-text>
        </v-tab-item>
       <v-tab-item :value="'Message'">
            <ThreadsList
              @getConversationId="getConversationId"
              @closeThreadList="null"
              topic="TradeResponse"
              type="MerchantMerchant"
              :key="key"
              :objectId="id"
              :conversationId="
                directOrderConversationList && directOrderConversationList.length
                  ? directOrderConversationList[0].conversationId
                  : null
              "
              :recipientMerchantId="supplierId"
              :recipientUserId="null"
              :createdByMerchantId="merchantId ? merchantId : null"
               :isUserBase="false"
            >
            </ThreadsList>
            <!-- <ConversationList></ConversationList> -->
          </v-tab-item>
        <v-tab-item :value="'Event'">
          <v-card-text flat>
            <trade-request-events></trade-request-events>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import ThreadsList from '@/components/core/conversation/components/ThreadsList.vue';
import Helper from '@/core/helpers';
const conversationRepository = () => RepoFactory.get('conversation');
const tradeRequestChatWithAdminRepository = () =>
  RepoFactory.get('tradeRequestChatWithAdmin');
import { RepoFactory } from '@/baseRepository/Factory';
import TradeRequestDirectForm from '@/modules/tradeRequests/components/TradeRequestDirectForm.vue';
import TradeRequestDirectInformation from '../components/TradeRequestDirectInformation.vue';
import TradeRequestEvents from '../components/TradeRequestEvents.vue';
import TradeRequestChatsWithAdminList from '../tradeRequsetChatWithAdmin/components/TradeRequestChatsWithAdminList.vue';
export default {
  data() {
    return {
      eventModal: false,
      tradeRequestChatWithAdminList: [],
      key: 0,
      directOrderConversationList: null,
      tradeRequestId: null,
    };
  },
  components: {
    TradeRequestDirectForm,
    TradeRequestDirectInformation,
    TradeRequestEvents,
    TradeRequestChatsWithAdminList,
    ThreadsList
  },
  created() {
    // this.getTradeRequestChatsWithAdmin(); TradeRequestSelectedItem
    //
      this.tradeRequestId = this.$route.params.id;
    if (this.tradeRequestId) {
      this.getdirectOrderConversaion();
    }
  },
  computed: {
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
      merchantId() {
      return this.$store.getters.currentMerchant;
    },
       supplierId() {
      return this.$store.getters.tradeRequestSelectedItem?.supplierId;
    },
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      },
    },
  },
  methods: {
    showDetailForm() {
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', true);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
    },
    closeForm() {
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$router.push({ path: '/trade-request-direct' });
    },
    getTradeRequestChatsWithAdmin() {
      const loader = this.$loading.show();
      let param = {
        tradeRequestId: this.id,
      };
      tradeRequestChatWithAdminRepository()
        .getTradeRequestChatsWithAdmin(this.baseUrl, {}, param)
        .then((res) => {
          this.tradeRequestChatWithAdminList = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    openPickAdminModal() {
      this.pickAdminModal = true;
    },
    closePickAdminDialog() {
      this.pickAdminModal = false;
    },
       getConversationId(val) {
      this.directOrderConversationList[0].conversationId = val;
      this.key += 1;
    },
    getdirectOrderConversaion() {
      const loader = this.$loading.show();
      let param = {
        objectId: this.tradeRequestId,
        type: 'MerchantMerchant',
        topic: 'TradeResponse',
        PageNumber: 1,
        ItemsPerPage: 5,
      };
      conversationRepository()
        .getConversation(
          this.contentBaseUrl,
          {MerchantId: this.merchantId},
          param
        )
        .then((res) => {
          this.directOrderConversationList = res.data.list;
        })
        .catch((err) => {
          console.log('err', err);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style></style>
